import { useState } from 'react';
import { Box, Grid } from '@mui/material';
import Layout from '../layout';
import Block from '../../../components/block';
import { ChartBar } from '../../../components/chart/ChartBar';
import { RatioPieChart } from '../../../components/chart/RatioPieChart';
import PeriodToggle, { PeriodType } from '../../../components/periodToggle';
import ChartTypeToggle from '../../../components/chartTypeToggle';

type ChartType = 'bar' | 'pie';

export default function Home() {
  const [chartType, setChartType] = useState<ChartType>('bar');
  const [period, setPeriod] = useState<PeriodType>('year');
  const [customRange, setCustomRange] = useState({
    from: '',
    to: '',
  });

  const handleChartChange = (newType: ChartType | null) => {
    if (newType) setChartType(newType);
  };

  const handlePeriodChange = (newPeriod: PeriodType | null) => {
    if (newPeriod) setPeriod(newPeriod);
  };

  return (
    <Layout>
      <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <ChartTypeToggle value={chartType} onChange={handleChartChange} sx={{ mb: 2 }} />
        <PeriodToggle
          value={period}
          onChange={handlePeriodChange}
          range={customRange}
          onRangeChange={setCustomRange}
        />
      </Box>
      {chartType === 'bar' ? (
        <ChartBar period={period} dataType="all" from={customRange.from} to={customRange.to} />
      ) : (
        <RatioPieChart period={period} from={customRange.from} to={customRange.to} />
      )}
      <Box sx={{ mt: 6 }}>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Block type="income" page={'home'} />
          </Grid>
          <Grid item md={6} xs={12}>
            <Block type="expense" page={'home'} />
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
